const mixin = {
  computed: {
    themeSettings() {
      return this.$store.state.registry.getModuleSetting('theme') || {}
    },
    hoverCardSetting() {
      return this.retrieveConcilioLayoutSetting('hoverDisplay')
    },
    carouselItemTheme() {
      return this.retrieveConcilioLayoutSetting('theme')
    },
    concilioSettings() {
      return Object.keys(this.themeSettings).includes('concilio-settings') ? this.themeSettings['concilio-settings'] : null
    },
    themeProductSettings() {
      return Object.keys(this.themeSettings).includes('products') ? this.themeSettings.products : null
    },
    themeConcilioSettings() {
      return Object.keys(this.themeSettings).includes('concilio-settings') ? this.themeSettings.concilioSettings : null
    },
    carouselItemSettings() {
      return this.themeSettings !== null ? this.themeSettings.sliders : null
    },
    carouselItemLayout() {
      const themeSettingsActive = (this.themeProductSettings !== null && Object.keys(this.themeProductSettings).includes('catalogue'))
      return (themeSettingsActive) ? `${this.themeProductSettings.catalogue}` || 'wine-product-grid-item-0001' : 'wine-product-grid-item-0001'
    }
  },
  methods: {
    retrieveConcilioLayoutSetting(payload) {
      const concilioSettingsExist = this.concilioSettings !== null
      const currentLayout = this.carouselItemLayout
      const layoutSettingsExist = (concilioSettingsExist) ? Object.keys(this.concilioSettings).includes(currentLayout) : false

      return (concilioSettingsExist) ? layoutSettingsExist ? this.concilioSettings[currentLayout][payload] : null : null
    }
  }
}

export default mixin
